export { default as InfoContent } from "./InfoContent";
